import { readBoolFlag, writeBoolFlag } from "@/utils/localFlag";

// Preferencias de UI del shell (persisten en localStorage para sobrevivir al
// reload que dispara el cambio de empresa activa). Namespaced: "ui".
const SIDEBAR_EXPANDED_KEY = "sidebarExpanded";

const state = () => ({
    // Restaurado de localStorage al crear el store (default: colapsado).
    sidebarExpanded: readBoolFlag(SIDEBAR_EXPANDED_KEY, false),
});

const mutations = {
    SET_SIDEBAR_EXPANDED: (state, value) => {
        state.sidebarExpanded = value;
    },
};

const actions = {
    // El side-effect de persistencia vive en la action (las mutations son
    // síncronas y triviales), igual que userAuth.setActiveCompany.
    setSidebarExpanded({ commit }, value) {
        commit("SET_SIDEBAR_EXPANDED", value);
        writeBoolFlag(SIDEBAR_EXPANDED_KEY, value);
    },
    toggleSidebar({ state, dispatch }) {
        dispatch("setSidebarExpanded", !state.sidebarExpanded);
    },
};

export default { namespaced: true, state, mutations, actions };
